import { useEffect, useRef } from 'react'

import { useStableCallback } from 'core/hooks'

const EVENTS = ['mousedown', 'touchstart']

const bind = (fn) => {
  EVENTS.forEach((event) => document.addEventListener(event, fn))
}

const unbind = (fn) => {
  EVENTS.forEach((event) => document.removeEventListener(event, fn))
}

const getAncestorIndex = (node) => {
  const count = document.body.children.length

  for (let i = 0; i < count; i++) {
    if (document.body.children[i].contains(node)) {
      return i
    }
  }
  return Number.POSITIVE_INFINITY
}

const isSameLevelOrAfter = (containerNode, clickedNode) => {
  const containerindex = getAncestorIndex(containerNode)
  const clickIndex = getAncestorIndex(clickedNode)

  return containerindex >= clickIndex
}

const useOnClickOutside = (func, passedRef, ...moreRefs) => {
  const localRef = useRef()

  const $ref = passedRef ?? localRef

  const $refs = [$ref, ...moreRefs]

  const onDocumentClick = useStableCallback((event) => {
    const allRefsSayOutside = $refs.every((ref) => {
      if (!ref?.current) return false
      if (!isSameLevelOrAfter(ref.current, event.target)) return false
      return !ref.current.contains(event.target)
    })
    if (allRefsSayOutside) {
      func(event)
    }
  })

  useEffect(() => {
    bind(onDocumentClick)
    return () => unbind(onDocumentClick)
  }, [onDocumentClick])

  return [$ref]
}

export default useOnClickOutside
